import * as angular from 'angular';
import {IScope} from 'angular';
import {CustomerFilter} from 'modules/customers/model/CustomerFilter';
import '../modal.scss'

declare var require: (path: string) => string;

interface LoanAmountModalScope extends IScope {
    filter: CustomerFilter;

    cancel(): void;

    apply(): void;

    clear(): void;

    onLoanAmountChange(min: number, max: number): void;

    ready: boolean;
}

export class LoanAmountModal implements ng.IComponentController {

    public filter: CustomerFilter;
    public opts: RangeOptionsDto;

    static instance = (
        $event: MouseEvent,
        filter: CustomerFilter,
        opts: RangeOptionsDto,
        parent: Element | string = document.body,
    ): angular.material.IDialogOptions => (
        {
            template: require('./loan-amount-modal.html'),
            controller: [
                '$scope',
                '$mdDialog',
                'filter',
                'opts',
                LoanAmountModal
            ],
            controllerAs: '$ctrl',
            bindToController: true,
            parent: angular.element(parent),
            targetEvent: $event,
            clickOutsideToClose: true,
            fullscreen: false,
            onComplete: (scope: LoanAmountModalScope) => {
                scope.$evalAsync(() => {
                    scope.ready = true;
                    scope.$broadcast('rzSliderForceRender');
                });
            },
            locals: {filter, opts}
        });

    constructor(
        private $scope: LoanAmountModalScope,
        private $mdDialog: angular.material.IDialogService,
        filter: CustomerFilter,
        opts: RangeOptionsDto
    ) {
        this.filter = angular.copy(filter);
        this.opts = opts;
        $scope.ready = false;

        Object.assign($scope, {
            filter: this.filter,
            cancel: this.cancel,
            apply: this.apply,
            clear: this.clear,
            onLoanAmountChange: this.onLoanAmountChange
        });
    }

    cancel = (): void => this.$mdDialog.cancel();

    apply = (): angular.IPromise<any> =>
        this.$mdDialog.hide(angular.copy(this.filter));

    clear = (): void => {
        const cleared = angular.copy(this.filter);
        cleared.minLoanAmount = null;
        cleared.maxLoanAmount = null;

        this.$mdDialog.hide(cleared);
    };

    onLoanAmountChange = (min: number, max: number): void => {
        this.filter.minLoanAmount = min;
        this.filter.maxLoanAmount = max;
    };
}

(LoanAmountModal as any).$inject = ['$scope', '$mdDialog', 'filter', 'opts'];
